const monthNames = [
  'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
  'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
];
const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];
const formatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian-nu-latn', {
  timeZone: 'Asia/Tehran', year: 'numeric', month: 'numeric', day: 'numeric'
});
const conversionCache = new Map();

function getPersianParts(date = new Date()) {
  const result = {};
  for (const part of formatter.formatToParts(date)) {
    if (part.type === 'year' || part.type === 'month' || part.type === 'day') {
      result[part.type] = Number(part.value);
    }
  }
  return { year: result.year, month: result.month, day: result.day };
}

function persianToGregorian(year, month, day) {
  const key = `${year}/${month}/${day}`;
  if (conversionCache.has(key)) return conversionCache.get(key);
  const start = Date.UTC(year + 621, 2, 15);
  for (let offset = 0; offset < 375; offset += 1) {
    const date = new Date(start + offset * 86400000);
    const parts = getPersianParts(date);
    if (parts.year === year && parts.month === month && parts.day === day) {
      conversionCache.set(key, date);
      return date;
    }
  }
  return null;
}

function monthLength(year, month) {
  if (month <= 6) return 31;
  if (month <= 11) return 30;
  return persianToGregorian(year, 12, 30) ? 30 : 29;
}

function normalizeDigits(value) {
  return String(value ?? '')
    .replace(/[۰-۹]/g, c => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(c)))
    .replace(/[٠-٩]/g, c => String('٠١٢٣٤٥٦٧٨٩'.indexOf(c)));
}

function parseValue(value) {
  const normalized = normalizeDigits(value).trim().replaceAll('-', '/').replaceAll('.', '/');
  const match = /^(\d{4})\/(\d{1,2})\/(\d{1,2})(?:\s+(\d{1,2}):(\d{1,2}))?$/.exec(normalized);
  if (!match) return null;
  const result = {
    year: Number(match[1]), month: Number(match[2]), day: Number(match[3]),
    hour: Number(match[4] ?? 0), minute: Number(match[5] ?? 0)
  };
  if (result.month < 1 || result.month > 12 || result.day < 1 || result.day > monthLength(result.year, result.month)) return null;
  if (result.hour < 0 || result.hour > 23 || result.minute < 0 || result.minute > 59) return null;
  return result;
}

function pad(value) { return String(value).padStart(2, '0'); }
function formatValue(state, withTime) {
  const date = `${state.year}/${pad(state.month)}/${pad(state.day)}`;
  return withTime ? `${date} ${pad(state.hour)}:${pad(state.minute)}` : date;
}

function createSelect(from, to, selected) {
  const select = document.createElement('select');
  for (let value = from; value <= to; value += 1) {
    const option = document.createElement('option');
    option.value = String(value);
    option.textContent = pad(value);
    option.selected = value === selected;
    select.append(option);
  }
  return select;
}

let activePicker = null;
let restoringInput = null;

function openPicker(input) {
  if (restoringInput === input || (activePicker?.input === input && activePicker.root.isConnected)) return;
  activePicker?.close(false);
  // site.js and the AJAX notebook entry can each include this module.
  document.querySelector('[data-persian-picker-root]')?.dispatchEvent(new Event('persian-picker-close'));
  const hasTime = input.hasAttribute('data-persian-datetime');
  const birthDate = input.hasAttribute('data-persian-birthdate');
  const now = getPersianParts();
  const parsed = parseValue(input.value);
  const state = parsed ?? { ...now, hour: 12, minute: 0 };
  const minYear = Math.min(now.year - 120, state.year);
  const maxYear = birthDate ? now.year : Math.max(now.year + 20, state.year);
  let viewYear = Math.min(state.year, maxYear);
  let viewMonth = birthDate && viewYear === now.year ? Math.min(state.month, now.month) : state.month;
  const root = document.createElement('div');
  root.dataset.persianPickerRoot = '';
  root.className = 'persian-picker-backdrop';
  root.innerHTML = `
    <section class="persian-picker" role="dialog" aria-modal="true" aria-label="انتخاب تاریخ شمسی">
      <div class="persian-picker-heading"><strong>انتخاب ${birthDate ? 'تاریخ تولد' : 'تاریخ شمسی'}</strong><button type="button" data-picker-close aria-label="بستن تقویم">×</button></div>
      <header>
        <button type="button" data-prev-month aria-label="ماه قبل">›</button>
        <div class="persian-picker-selectors"><label><span>ماه</span><select data-picker-month aria-label="انتخاب ماه"></select></label><label><span>سال</span><select data-picker-year aria-label="انتخاب سال"></select></label></div>
        <button type="button" data-next-month aria-label="ماه بعد">‹</button>
      </header>
      <p class="persian-picker-title" data-picker-title aria-live="polite"></p>
      <div class="persian-picker-weekdays">${weekDays.map(x => `<span>${x}</span>`).join('')}</div>
      <div class="persian-picker-days" data-picker-days></div>
      <div class="persian-picker-time" data-picker-time></div>
      <footer>
        <button type="button" class="button button-ghost" data-picker-clear>پاک‌کردن</button>
        <button type="button" class="button button-secondary" data-picker-today>امروز</button>
        <button type="button" class="button" data-picker-confirm>تأیید</button>
      </footer>
    </section>`;
  const title = root.querySelector('[data-picker-title]');
  const days = root.querySelector('[data-picker-days]');
  const time = root.querySelector('[data-picker-time]');
  const monthSelect = root.querySelector('[data-picker-month]');
  const yearSelect = root.querySelector('[data-picker-year]');
  const previous = root.querySelector('[data-prev-month]');
  const next = root.querySelector('[data-next-month]');
  const digits = new Intl.NumberFormat('fa-IR', { useGrouping: false });
  monthNames.forEach((name, index) => monthSelect.add(new Option(name, String(index + 1))));
  for (let year = maxYear; year >= minYear; year -= 1) yearSelect.add(new Option(digits.format(year), String(year)));

  const abort = new AbortController();
  const previousOverflow = document.body.style.overflow;
  const close = (restore = true) => {
    abort.abort();
    root.remove();
    document.body.style.overflow = previousOverflow;
    input.setAttribute('aria-expanded', 'false');
    activePicker = null;
    if (restore && input.isConnected) {
      restoringInput = input;
      input.focus({ preventScroll: true });
      restoringInput = null;
    }
  };
  activePicker = { input, root, close };
  root.addEventListener('persian-picker-close', () => close(false), { once: true });

  if (hasTime) {
    const hour = createSelect(0, 23, state.hour);
    const minute = createSelect(0, 59, state.minute);
    hour.addEventListener('change', () => { state.hour = Number(hour.value); });
    minute.addEventListener('change', () => { state.minute = Number(minute.value); });
    const hourLabel = document.createElement('label');
    hourLabel.innerHTML = '<span>ساعت</span>';
    hourLabel.append(hour);
    const minuteLabel = document.createElement('label');
    minuteLabel.innerHTML = '<span>دقیقه</span>';
    minuteLabel.append(minute);
    time.append(hourLabel, minuteLabel);
  } else time.remove();

  function setMonth(year, month) {
    viewYear = Math.max(minYear, Math.min(maxYear, year));
    viewMonth = Math.max(1, Math.min(12, month));
    if (birthDate && viewYear === now.year) viewMonth = Math.min(viewMonth, now.month);
    state.year = viewYear;
    state.month = viewMonth;
    state.day = Math.min(state.day, monthLength(viewYear, viewMonth));
    if (birthDate && viewYear === now.year && viewMonth === now.month) state.day = Math.min(state.day, now.day);
    render();
  }

  function render() {
    title.textContent = `${monthNames[viewMonth - 1]} ${digits.format(viewYear)}`;
    monthSelect.value = String(viewMonth);
    yearSelect.value = String(viewYear);
    [...monthSelect.options].forEach(option => { option.disabled = birthDate && viewYear === now.year && Number(option.value) > now.month; });
    previous.disabled = viewYear === minYear && viewMonth === 1;
    next.disabled = viewYear === maxYear && viewMonth === (birthDate ? now.month : 12);
    days.replaceChildren();
    const first = persianToGregorian(viewYear, viewMonth, 1);
    const firstIndex = first ? (first.getUTCDay() + 1) % 7 : 0;
    for (let index = 0; index < firstIndex; index += 1) {
      const spacer = document.createElement('span'); spacer.className = 'empty'; days.append(spacer);
    }
    for (let day = 1; day <= monthLength(viewYear, viewMonth); day += 1) {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = digits.format(day); button.dataset.pickerDay = String(day);
      const selected = state.year === viewYear && state.month === viewMonth && state.day === day;
      button.classList.toggle('selected', selected);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${digits.format(day)} ${monthNames[viewMonth - 1]} ${digits.format(viewYear)}`);
      if (now.year === viewYear && now.month === viewMonth && now.day === day) button.classList.add('today');
      button.disabled = birthDate && viewYear === now.year && viewMonth === now.month && day > now.day;
      button.addEventListener('click', () => { state.year = viewYear; state.month = viewMonth; state.day = day; render(); root.querySelector(`[data-picker-day="${day}"]`)?.focus({ preventScroll: true }); });
      days.append(button);
    }
  }

  monthSelect.addEventListener('change', () => setMonth(viewYear, Number(monthSelect.value)));
  yearSelect.addEventListener('change', () => setMonth(Number(yearSelect.value), viewMonth));
  previous.addEventListener('click', () => setMonth(viewMonth === 1 ? viewYear - 1 : viewYear, viewMonth === 1 ? 12 : viewMonth - 1));
  next.addEventListener('click', () => setMonth(viewMonth === 12 ? viewYear + 1 : viewYear, viewMonth === 12 ? 1 : viewMonth + 1));
  root.querySelector('[data-picker-today]').addEventListener('click', () => { Object.assign(state, now); setMonth(now.year, now.month); });
  root.querySelector('[data-picker-clear]').addEventListener('click', () => {
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    close();
  });
  root.querySelector('[data-picker-confirm]').addEventListener('click', () => {
    input.value = formatValue(state, hasTime);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    close();
  });
  root.querySelector('[data-picker-close]').addEventListener('click', () => close());
  root.addEventListener('click', event => { if (event.target === root) close(); });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...root.querySelectorAll('button:not([disabled]), select:not([disabled])')];
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }, { signal: abort.signal });
  document.body.append(root);
  document.body.style.overflow = 'hidden';
  input.setAttribute('aria-expanded', 'true');
  setMonth(viewYear, viewMonth);
  (birthDate ? yearSelect : monthSelect).focus({ preventScroll: true });
}

export function initializePersianDatePickers(scope = document) {
  scope.querySelectorAll('[data-persian-date], [data-persian-datetime]').forEach(input => {
    if (input.dataset.persianPickerBound === 'true') return;
    input.dataset.persianPickerBound = 'true';
    input.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('aria-expanded', 'false');
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    if (input.hasAttribute('data-persian-birthdate')) { input.readOnly = true; input.inputMode = 'none'; }
    input.addEventListener('focus', () => openPicker(input));
    input.addEventListener('click', () => openPicker(input));
    input.addEventListener('keydown', event => { if (event.key === 'ArrowDown') { event.preventDefault(); openPicker(input); } });
  });
}
